<template>
  <div v-loading="loading">
    <app-header></app-header>

    <!-- Left side column. contains the sidebar -->
    <app-sidebar :userDocument="this.$route.params.userDocument"></app-sidebar>

    <!-- Content Wrapper. Contains page content -->
    <router-view></router-view>
    <!-- /.content-wrapper -->

    <app-footer></app-footer>

    <control-sidebar></control-sidebar>
  </div>
</template>

<script>
  import Sidebar from './partials/Sidebar.vue'
  import Header from './partials/Header.vue'
  import Footer from './partials/Footer.vue'
  import ControlSidebar from './partials/ControlSidebar.vue'
const Auth = require('../services/Authentication/auth')
const to = require('await-to-js').default

  export default {
    name: 'Dashboard',
    components: {
      'app-sidebar': Sidebar,
      'app-header': Header,
      'app-footer': Footer,
      'control-sidebar': ControlSidebar
    },
    data: function () {
      return {
        userDocument: {}
      }
    },
    beforeCreate() {
              //needs to be moved to more centralized location
   
      console.log("user authenticated", this.$store)
      if  (!this.$store.state.isUserAuthenticated){
                this.$router.push('/login')
              
      }
    
    
    },
   async beforeMount(){
      this.userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
  let userErr, userRes
          [userErr, userRes] = await to(Auth.getUser({ UID: this.userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')

          } 
     console.log("userDoc", this.$route.params)
      if (this.$route.params && this.$route.params.userDocument){
        this.userDocument =  this.$route.params.userDocument
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?cdd799ac